import { Box, Card, CardContent } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useMemo, useState } from "react";
import { ActionFactory } from "../../fstn/actionFactory";
import { Cursor } from "../../fstn/cursor";
import { Network } from "../../fstn/network";
import { parseScriptParts } from "../scriptParser";
import State from "./State";

const useStyles = makeStyles((theme) => ({
    card: {
        width: "297mm",
        display: 'flex',
        margin: theme.spacing(2),
        flexGrow: 1,
        flexDirection: 'column',
        overflowY: "auto"
    },
    content: {
        margin: '1%',
        height: "100%",
        flexGrow: 1,
        fontFamily: 'monospace',
        fontSize: "large",
    },
}));


interface Props
{
    network: Network
    factory: ActionFactory
}

export default function InteractiveScript({ network, factory }: Props)
{
    const classes = useStyles();
    const [choices, setChoices] = useState<{ [key: string]: string }>({});

    const script = useMemo(() =>
    {
        const script: React.ReactNode[] = [];

        if (!network) return script;

        const cursor = new Cursor(network, factory);
        const handleChoice = (state: string, choice: string) =>
        {
            setChoices(choices => ({ ...choices, [state]: choice }));
        };
        const visited: string[] = [];

        while (!visited.includes(cursor.state))
        {
            const state = cursor.state;
            const triggers = cursor.triggers;
            let trigger = 'continue';

            visited.push(state);
            if (triggers.length > 1)
            {
                trigger = choices[state] || triggers[0];
                choices[state] = trigger;
            }

            const stateData = network.states.get(cursor.state);
            if (stateData)
            {
                const scriptParts = parseScriptParts(stateData);
                if (scriptParts.text && scriptParts.text.length > 0) 
                {
                    script.push(<State
                        key={state} triggers={triggers} state={state} choice={choices[state]}
                        script={scriptParts.text} onChoice={handleChoice} />);
                }
            }

            cursor.trigger(trigger);
        }
        return script;
    }, [choices, factory, network]);

    return <Card className={classes.card}>
        <CardContent className={classes.content}>
            <Box>{script}</Box>
        </CardContent>
    </Card>
}